export enum UserRole {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  SELLER = 'SELLER',
}

export interface User {
  id: number;
  name: string;
  email: string;
  role: UserRole;
  active: boolean;
  mustChangePassword: boolean;
  twoFactorEnabled?: boolean;
  products?: ProductSummary[];
  createdAt: string;
  updatedAt: string;
}

export interface ProductSummary {
  id: number;
  name: string;
  slug: string;
}

export interface AuthTokens {
  accessToken: string;
  expiresIn: number;
}

export interface AuthResponse {
  user: User;
  tokens: AuthTokens;
  requiresTwoFactor?: boolean;
}

export interface CreateUserRequest {
  name: string;
  email: string;
  role: UserRole;
  productIds: number[];
}

export interface UpdateUserRequest {
  name?: string;
  role?: UserRole;
  productIds?: number[];
  active?: boolean;
}
